let skills = [
  {
    name: "React",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png",
    percent: 80,
  },
  {
    name: "CP",
    img: "https://www.andreafiori.net/img/social/og/competitive-programming.gif",
    percent: 75,
  },
  {
    name: "NodeJs",
    img: "https://www.quantumversity.com/wp-content/uploads/2020/11/Fundamentals-of-Node.png",
    percent: 70,
  },
  {
    name: "Machine Learning",
    img: "https://miro.medium.com/max/1400/1*cG6U1qstYDijh9bPL42e-Q.jpeg",
    percent: 75,
  },
  {
    name: "Express",
    img: "https://miro.medium.com/max/1400/1*XP-mZOrIqX7OsFInN2ngRQ.png",
    percent: 75,
  },
  {
    name: "MongoDB",
    img: "https://www.cloudsavvyit.com/p/uploads/2021/07/f5932bc2.jpg?width=1198&trim=1,1&bg-color=000&pad=1,1",
    percent: 80,
  },
  {
    name: "DSA",
    img: "https://wachemo-elearning.net/wp-content/uploads/2021/01/DATA-STRUCTURES-with-Python.png",
    percent: 85,
  },
];

export default skills;
